import "./hero.css";

const OfferBanner = () => {
  return (
    <div
      className="text-white py-5 container-fluid"
      style={{
        backgroundColor: "#b78b2f",
        fontFamily: "'Barlow Condensed', sans-serif",
        borderRadius: "10px",
        paddingInline: "20px",
      }}
    >
      <div className="container-fluid text-center px-3 px-md-4">
        <h2 data-sal='slide-down' data-sal-duration="2000" data-sal-delay="400"
          className="mb-4"
          style={{
            fontSize: "2.2rem",
          }}
        >
          <div className="d-flex flex-column flex-md-row justify-content-center text-center">
            <span className="text-white d-block d-md-inline me-md-2">
              Unbeatable Bathroom Renovation Offers –
            </span>
            <span className="text-white d-block d-md-inline">
              Limited Time Only!
            </span>
          </div>
        </h2>

     <p className="mb-1 fs-5" data-sal="slide-up" data-sal-duration="700">
  Save <strong>$2,000</strong> on a full bathroom renovation with a{" "}
  <strong>tub enclosure</strong> (no shower)
</p>
<p className="mb-4 fs-5" data-sal="slide-up" data-sal-duration="700" data-sal-delay="200">
  Save <strong>$4,000</strong> on a full bathroom renovation with a{" "}
  <strong>shower</strong> (no bathtub)
</p>

<h5 className="fw-bold text-uppercase mb-3 fs-3" data-sal="fade" data-sal-duration="600" data-sal-delay="300">
  What’s Included:
</h5>
<p className="mb-1 fs-5" data-sal="slide-left" data-sal-duration="600">All finishing materials</p>
<p className="mb-1 fs-5" data-sal="slide-left" data-sal-duration="600" data-sal-delay="100">All raw materials</p>
<p className="mb-1 fs-5" data-sal="slide-left" data-sal-duration="600" data-sal-delay="200">Demolition & garbage removal</p>
<p className="mb-4 fs-5" data-sal="slide-left" data-sal-duration="600" data-sal-delay="300">Full labor</p>

<h5 className="fw-bold text-uppercase mb-3 fs-3" data-sal="fade" data-sal-duration="600">
  10-Year Unlimited Warranty On All Work
</h5>
<p className="mb-4 fs-3" data-sal="zoom-in" data-sal-duration="600">
  Transform your bathroom with exceptional savings today!
</p>

<button
  className="btn btn-dark custom-btn px-4 px-md-5 py-3 text-uppercase fw-normal rounded-pill fs-6 fs-md-5"
  data-sal="slide-up"
  data-sal-duration="800"
  data-sal-delay="200"
>
  Get Started Today!
</button>

      </div>
    </div>
  );
};

export default OfferBanner;
